import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import { Modal } from 'react-bootstrap';
import PastRolesDisplay from '../common/PastRolesDisplay';
import Loading from '../common/Loading';
import { postRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import { date } from '../../dateUtils';
import { orderByStartDate } from '../../arrayUtils';
import './AddProposalPastRoles.scss';
var PastRolesQuestion = /*#__PURE__*/lazy(function () {
  return import('../common/PastRolesQuestion');
});
var AddProposalPastRoles = /*#__PURE__*/function (_Component) {
  function AddProposalPastRoles(props) {
    var _this;
    _classCallCheck(this, AddProposalPastRoles);
    _this = _callSuper(this, AddProposalPastRoles, [props]);
    _this.state = {
      showModal: false,
      errors: [],
      pastRoles: props.pastRoles,
      proposalPastRolesIds: props.selectedPastRolesIds,
      selectedPastRolesIds: props.selectedPastRolesIds,
      newPastRoles: []
    };
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.toggleLink = _this.toggleLink.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.renderSelectPastRoles = _this.renderSelectPastRoles.bind(_this);
    return _this;
  }
  _inherits(AddProposalPastRoles, _Component);
  return _createClass(AddProposalPastRoles, [{
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "toggleLink",
    value: function toggleLink(currentInviteStatus, pastRole) {
      var _this2 = this;
      var selectedPastRolesIds = this.state.selectedPastRolesIds;
      if (currentInviteStatus) {
        this.setState({
          selectedPastRolesIds: selectedPastRolesIds.filter(function (i) {
            return i !== pastRole.id;
          })
        }, function () {
          _this2.handleSubmit([]);
        });
      } else {
        var newSelectedPastRoles = update(selectedPastRolesIds, {
          $push: [pastRole.id]
        });
        this.setState({
          selectedPastRolesIds: newSelectedPastRoles
        }, function () {
          _this2.handleSubmit([]);
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(newPastRoles) {
      var _this3 = this;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        proposalPastRolesUrl = _this$props.proposalPastRolesUrl,
        proposal = _this$props.proposal;
      var _this$state = this.state,
        selectedPastRolesIds = _this$state.selectedPastRolesIds,
        pastRoles = _this$state.pastRoles;
      return postRequest(proposalPastRolesUrl, {
        selected_past_roles_ids: selectedPastRolesIds,
        new_past_roles: newPastRoles
      }, csrfToken).then(function (response) {
        _this3.setState({
          pastRoles: pastRoles.concat(response.data.new_past_roles),
          proposalPastRolesIds: response.data.selected_past_roles_ids,
          selectedPastRolesIds: response.data.selected_past_roles_ids,
          newPastRoles: []
        });
        analyticsTrack('Submitted Proposal Past Roles', {
          resource_id: proposal.id
        });
      });
    }
  }, {
    key: "renderDisplay",
    value: function renderDisplay() {
      var _this$state2 = this.state,
        pastRoles = _this$state2.pastRoles,
        proposalPastRolesIds = _this$state2.proposalPastRolesIds;
      var _this$props2 = this.props,
        isRep = _this$props2.isRep,
        canEdit = _this$props2.canEdit;
      if ((proposalPastRolesIds.length === 0 || pastRoles.length === 0) && canEdit) {
        return /*#__PURE__*/React.createElement("div", {
          className: "body-text-2"
        }, /*#__PURE__*/React.createElement("h1", {
          className: "medium-weight mb-2 ".concat(isRep && 'rep-header')
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-gem"
        }), "Relevant Past Roles"), /*#__PURE__*/React.createElement("div", {
          className: "mb-4"
        }, "Highlight related past roles to ensure the employer of your\n            relevant experience."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
          tabIndex: 0,
          role: "link",
          className: "add-proposal-past-roles",
          onClick: this.handleShowModal
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-plus"
        }), "Add relevant past roles")));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "medium-weight mb-2 ".concat((isRep || !canEdit) && 'rep-header')
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-gem"
      }), "Relevant Past Roles", canEdit && /*#__PURE__*/React.createElement("a", {
        tabIndex: 0,
        role: "link",
        className: "align edit-proposal-past-roles",
        onClick: this.handleShowModal
      }, "Edit")), /*#__PURE__*/React.createElement("div", {
        className: "mt-3"
      }, /*#__PURE__*/React.createElement(PastRolesDisplay, {
        pastRoles: pastRoles.filter(function (pr) {
          return proposalPastRolesIds.includes(pr.id);
        }),
        fullView: isRep || canEdit,
        onProposalPage: true
      })));
    }
  }, {
    key: "renderModalSubtext",
    value: function renderModalSubtext() {
      var pastRoles = this.state.pastRoles;
      if (pastRoles.length === 0) {
        return 'Organize and edit past roles to highlight your experiences relevant to this project.';
      }
      return 'Select the relevant past roles for this project. You can always edit your past role history in My Profile.';
    }
  }, {
    key: "renderSelectPastRoles",
    value: function renderSelectPastRoles() {
      var _this4 = this;
      var _this$state3 = this.state,
        pastRoles = _this$state3.pastRoles,
        selectedPastRolesIds = _this$state3.selectedPastRolesIds;
      return /*#__PURE__*/React.createElement("div", {
        className: "past-roles"
      }, orderByStartDate(pastRoles).map(function (pastRole) {
        return /*#__PURE__*/React.createElement("div", {
          key: pastRole.title,
          tabIndex: 0,
          role: "button",
          className: "align select-past-role body-text-2 mb-3",
          onClick: function onClick() {
            return _this4.toggleLink(selectedPastRolesIds.includes(pastRole.id), pastRole);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "past-roles-info"
        }, /*#__PURE__*/React.createElement("div", {
          className: "fs-hide medium-weight"
        }, pastRole.title), /*#__PURE__*/React.createElement("div", {
          className: "fs-hide"
        }, pastRole.role), /*#__PURE__*/React.createElement("div", {
          className: "fs-hide"
        }, pastRole.company_name), /*#__PURE__*/React.createElement("div", {
          className: "mute fs-hide"
        }, date(pastRole.start_date, pastRole.end_date, pastRole.current))), /*#__PURE__*/React.createElement("div", {
          className: "switch"
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          checked: selectedPastRolesIds.includes(pastRole.id),
          readOnly: true
        }), /*#__PURE__*/React.createElement("span", {
          className: "slider round"
        })));
      }));
    }
  }, {
    key: "renderNewPastRoles",
    value: function renderNewPastRoles() {
      var _this$state4 = this.state,
        selectedPastRolesIds = _this$state4.selectedPastRolesIds,
        newPastRoles = _this$state4.newPastRoles;
      return /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, null)
      }, /*#__PURE__*/React.createElement(PastRolesQuestion, {
        questionKey: "past_roles",
        newPastRoles: newPastRoles,
        handleChange: this.handleSubmit,
        closeModal: this.handleCloseModal,
        showBorder: selectedPastRolesIds.length > 0,
        disableSubmit: selectedPastRolesIds.length === 0,
        onProposalPage: true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state5 = this.state,
        selectedPastRolesIds = _this$state5.selectedPastRolesIds,
        pastRoles = _this$state5.pastRoles,
        showModal = _this$state5.showModal;
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide relevant-past-roles"
      }, this.renderDisplay(), /*#__PURE__*/React.createElement(Modal, {
        dialogClassName: "proposal-past-roles-modal-size",
        className: "style-guide",
        show: showModal,
        onHide: this.handleShowModal,
        onEscapeKeyDown: this.handleShowModal
      }, /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        onClick: this.handleCloseModal,
        role: "button",
        tabIndex: 0,
        className: "close-modal"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-times fa-lg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "proposal-past-roles-modal body-text-2"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-2"
      }, "Select relevant past roles for this project."), /*#__PURE__*/React.createElement("div", {
        className: "mb-4 subtext"
      }, "You may update your past roles in My Profile to present the most up to date information on this proposal."), /*#__PURE__*/React.createElement("div", {
        className: "add-new-past-role"
      }, selectedPastRolesIds.length + pastRoles.length > 0 && this.renderSelectPastRoles(), this.renderNewPastRoles())))));
    }
  }]);
}(Component);
AddProposalPastRoles.propTypes = {
  proposal: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  proposalPastRolesUrl: PropTypes.string.isRequired,
  pastRoles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedPastRolesIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  isRep: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired
};
export default AddProposalPastRoles;